let hasBeenSet = false;
let maxClientW = 1920;


export const setRem = (doc, win, maxW) => {
  maxClientW = maxW || maxClientW;
  const html = doc.getElementsByTagName("html")[0];
  const reFontSize = function () {
    const clientW = doc.documentElement.clientWidth || doc.body.clientWidth;
    // console.log("clientW"+clientW)
    if (!clientW) {
      return;
    }
    if (clientW <= maxClientW) {
      html.style.fontSize = 100 * (clientW / 750) + "px";
    } else {
      html.style.fontSize = 100 * (maxClientW / 750) + "px";
    }
  };
  if (hasBeenSet) {
    reFontSize();
    return;
  }
  const reEvt = "orientationchange" in win ? "orientationchange" : "resize";

  html.style.opacity = 1;
  win.addEventListener(reEvt, reFontSize);
  hasBeenSet = true;
  // DOMContentLoaded->dom加载完就执行,onload要dom/css/js都加载完才执行
  // doc.addEventListener("DOMContentLoaded", reFontSize);
  if (doc) {
    reFontSize();
  }
};
